import { gql } from 'apollo-boost';

/**
 * GraphQL query to fetch customer and accounts data for the dashboard
 * This query fetches all fields needed for the new dashboard including:
 * - Customer details, application status, FATCA status
 * - All accounts with balances, products, transactions, maturity info
 * - Products catalog, pending accounts, ISA allowance, new account options
 */
export const GET_CUSTOMER_AND_ACCOUNTS = gql`
    query GetCustomerAndAccounts($id : ID!){
        customer(id:$id) {
            firstName
            middleName
            lastName
            id
            mobileNumber
            applicationStatus
            showFatcaPopup
            accounts {
                accountNumber
                balance
                availableBalance
                id
                linkedAccountNumber
                linkedAccountSortCode
                interestPaid
                product {
                    productType
                    interestRate
                    name
                    issueNumber
                    maxWithdrawalLimit
                    lowerInterestRateAmount
                    stepUpAmount
                    interestRateTiers {
                        minBalance
                        maxBalance
                        rate
                    }
                    productTerm {
                        value
                        unit
                    }
                    code
                    rateChanges {
                        rate
                        aerRate
                        issue
                        scheduledFor
                        reason
                        rateNotificationAt
                    }
                }
                sortCode
                accountStatus
                fundingEndDate
                fundingWindowMinutesLeft
                maturity {
                    maturityDate
                    maturityInstructionWindowStatus
                    maturityInstruction
                    maturityWindowCloseDate
                    maturityWindowCloseTime
                    destinationAccountId
                    rolloverAccountProductId
                    availableRolloverRates {
                        productId
                        rate
                    }
                }
                transactions {
                    reference
                    transactionId
                    amount
                    updatedBalance
                    bookingDate
                    counterpartAccountNumber
                    counterpartSortCode
                    action
                    interestPeriodFrom
                    interestPeriodTo
                }
                pendingTransactions {
                    pendingTransactionId
                    counterpartAccountNumber
                    counterpartSortCode
                    counterpartAccountType
                    toLinkedAccount
                    amount
                    withdrawalDate
                    state
                    closeAccount
                    allowClosure
                }
                notice {
                    noticePeriod
                    noticePeriodUnit
                }
                transferAccounts {
                    id
                    accountNumber
                    sortCode
                    balance
                    availableBalance
                    product {
                        productType
                        interestRate
                        name
                        maxWithdrawalLimit
                        lowerInterestRateAmount
                        stepUpAmount
                        interestRateTiers {
                            minBalance
                            maxBalance
                            rate
                        }
                        productTerm {
                            value
                            unit
                        }
                    }
                }
                transferIn {
                    status
                    lastUpdatedAt
                }
                transferOut {
                    status
                    lastUpdatedAt
                }
            }
            newAccounts {
                productId
                qualify
                productName
                productRate
                productAerRate
                productType
            }
            products {
                id
                name
                rate
                aerRate
                issueNumber
                rateChangeNotification
                code
                type
                summaryBoxFileName
                productTermsFileName
                productTerm {
                    value
                    unit
                }
                interestRateTiers {
                    minBalance
                    maxBalance
                    rate
                    aerRate
                }
            }
            pendingAccounts {
                productId
            }
            isaAllowance {
                taxYear
                totalAllowance
                usedAllowance
                remainingAllowance
                holdAllowance
            }
        }
    }
`;
